// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getCardListStatus: {
    data: null,
  },
  addCardStatus: {
    data: null,
  },
  updateCardStatus: {
    data: null,
  },
  deleteCardStatus: {
    data: null,
  },
  getBillingSubscriptionsStatus: {
    data: null,
  },
  getSubscriptionDetailsStatus: {
    data: null,
  },
  addBillingInformationStatus: {
    data: null,
  },
  cancelRenewalSubscriptionStatus: {
    data: null,
  },
  autoRenewalSubscriptionStatus: {
    data: null,
  },
  getBillingTransactionsDetailsStatus: {
    data: null,
  },
};
